import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { IEffect } from '../../actions/effects/IEffect';
import { app } from '../../app';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { getMatch2AssetPath } from '../../util/assets';
import { blockViewAssets } from '../../util/blockTools';
import { BalloonBoxBlockEntity } from './BalloonBoxBlockEntity';

export class BalloonBoxBlockEffect implements IEffect {
  private readonly scene: GameScene;

  constructor(scene: GameScene) {
    this.scene = scene;
  }

  public static assets() {
    return blockViewAssets('balloonBox');
  }

  public async execute() {
    //
  }

  public async playExplodeAnimation(entity: BalloonBoxBlockEntity) {
    const container = new Container();
    const movieclip = new MovieClip({
      superview: container.view,
      url: getMatch2AssetPath('blocks/balloonBox/movieclip'),
    });
    const overlay = spawnOverlayEntity(
      this.scene,
      entity.c.position.mapPosition,
      entity.c.block.props,
      () => container,
      'foreground',
    );
    await movieclip.playAsync('balloonbox_explode_overlay');
    despawnOverlayEntity(this.scene, overlay);
  }

  public async playBreakParticles(entity: BalloonBoxBlockEntity) {
    const textures: string[] = [];

    textures.push(
      getMatch2AssetPath(
        'blocks/balloonBox/particles/particle_balloon_0001.png',
      ),
      getMatch2AssetPath(
        'blocks/balloonBox/particles/particle_balloon_0002.png',
      ),
      getMatch2AssetPath(
        'blocks/balloonBox/particles/particle_balloon_0003.png',
      ),
      getMatch2AssetPath(
        'blocks/balloonBox/particles/particle_balloon_0004.png',
      ),
      getMatch2AssetPath(
        'blocks/balloonBox/particles/particle_balloonbox_0001.png',
      ),
      getMatch2AssetPath(
        'blocks/balloonBox/particles/particle_balloonbox_0002.png',
      ),
      getMatch2AssetPath(
        'blocks/balloonBox/particles/particle_balloonbox_0003.png',
      ),
    );

    const particles = app.particles.create({
      textures,
      rate: 0,
      limit: 20,
      emitterDuration: 0,
      duration: 2.5,
      velocity: { x: 0, y: -400 },
      scale: [
        { x: 0.7, y: 0.7 },
        { x: 1.1, y: 1.1 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [300, 500] },
        { type: 'gravity', gravity: { x: 0, y: 2000 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic' },
      ],
    });

    const position = entity.c.position.mapPosition.clone();
    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }
}
